import { F0Alert } from '@factorialco/f0-react'

import { BlockingIssue } from 'modules/integrations/hooks/SyncContext/blockingIssues'

type BlockingIssueItemProps = {
  blockingIssue: BlockingIssue
}

export function BlockingIssueItem({ blockingIssue }: BlockingIssueItemProps) {
  return (
    <F0Alert
      variant="critical"
      title={blockingIssue.title}
      description={blockingIssue.description}
      link={
        blockingIssue.buttonUrl && blockingIssue.buttonLabel
          ? { label: blockingIssue.buttonLabel, href: blockingIssue.buttonUrl }
          : undefined
      }
    />
  )
}
